

/// <reference path="ProxyPaymentEntity.ts" />

// Generated class AdyenProxyPaymentEntity_ManagedObject

class AdyenProxyPaymentEntity_ManagedObject extends ProxyPaymentEntity
{
}
